<template>
	<div>
		<div
			v-if="paymentsFiltered.length"
			class="text-capitalize text-left subtitle-1 py-2 rounded"
		>
			Pagos registrados en {{ formatTittle(title) }} del {{ formatTittleYear(title) }}
		</div>
		<v-row>
			<v-col v-for="(payment, key) in paymentsFiltered" :key="key" cols="12">
				<v-card flat class="text-left" :class="globalBackground">
					<v-list-item three-line>
						<v-list-item-content style="overflow-y: auto; max-height: 60px;">
							<v-list-item-title class="subtitle-1 mb-3">
								{{ payment.paymentType }}
							</v-list-item-title>
							<v-list-item-subtitle>
								Desde el
								<span>{{ formatStartDate(payment.startDate) }}</span> al
								<span>{{ formatEndDate(payment.endDate) }}</span>
							</v-list-item-subtitle>
							<v-list-item-subtitle v-if="payment.voucher.url">
								<a target="_blank" :href="payment.voucher.url">
									Ver comprobante de pago
								</a>
							</v-list-item-subtitle>
							<v-list-item-subtitle v-else class="primary--text">
								Sin comprobante de pago
							</v-list-item-subtitle>
							<div v-if="payment.comments.length" class="subtitle-2 text--secondary">
								Notas
							</div>
							<small
								v-for="(comment, i) in payment.comments"
								:key="i"
								class="text-lowercase d-block caption text--secondary"
							>
								{{ comment }}
							</small>
						</v-list-item-content>
					</v-list-item>
					<v-card-actions class="pt-0">
						<v-spacer></v-spacer>
						<span class="title ma-2">
							<span class="success--text">$</span>
							{{ payment.mount }}
						</span>
						<v-edit-dialog @save="saveComment(payment)">
							<v-btn icon>
								<v-icon>mdi-comment-plus</v-icon>
							</v-btn>
							<template v-slot:input>
								<v-text-field
									v-model="newComment"
									label="Comentario"
									single-line
									counter
								></v-text-field>
							</template>
						</v-edit-dialog>
						<!-- confirm delete -->
						<v-menu left transition="scale-transition">
							<template v-slot:activator="{ on, attrs }">
								<v-btn v-bind="attrs" icon v-on="on">
									<v-icon>mdi-delete</v-icon>
								</v-btn>
							</template>
							<v-card>
								<v-card-title class="title text-center">Eliminar pago</v-card-title>
								<v-card-text class="text-center">
									¿Estas seguro de eliminar este pago?
								</v-card-text>
								<div class="mx-2">
									<v-btn color="primary" small text>
										Cancelar
									</v-btn>
									<v-btn
										color="primary"
										small
										text
										@click="deletePayment(payment._id)"
									>
										Aceptar
									</v-btn>
								</div>
							</v-card>
						</v-menu>
					</v-card-actions>
				</v-card>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import moment from 'moment';
import { mapActions } from 'vuex';

export default {
	name: 'PaymentList',
	props: {
		idPlace: { type: String, required: true },
		paymentsList: { type: Array, default: () => [] },
		title: { type: String, default: '' },
		wordFilter: { type: String, default: '' },
	},
	data() {
		return {
			newComment: '',
			paymentsFiltered: [],
		};
	},
	watch: {
		wordFilter() {
			this.filter();
		},
		paymentsList(newValue) {
			this.paymentsFiltered = [...newValue];
		},
	},
	created() {
		this.paymentsFiltered = [...this.paymentsList];
	},
	methods: {
		formatTittle(item) {
			return moment(item).format('MMMM');
		},
		formatTittleYear(item) {
			return moment(item).format('YYYY');
		},
		filter() {
			this.paymentsFiltered = this.paymentsList.filter(
				item =>
					item.startDate.toLowerCase().indexOf(this.wordFilter.toLowerCase()) > -1 ||
					item.endDate.toLowerCase().indexOf(this.wordFilter.toLowerCase()) > -1 ||
					item.mount.indexOf(this.wordFilter.toLowerCase()) > -1 ||
					item.paymentType.toLowerCase().indexOf(this.wordFilter.toLowerCase()) > -1
			);
		},
		formatStartDate(date) {
			return moment(date).format('LL');
		},
		formatEndDate(date) {
			return moment(date).format('LL');
		},
		async saveComment(item) {
			const date = moment().format('YYYY-MM-DD hh:mm');
			const temp = [...item.comments, `${date}: ${this.newComment}`];
			await this.edit({ comments: temp, id: item._id });
			this.newComment = '';
			await this.fetchPayments(this.idPlace);
		},
		deletePayment(id) {
			this.delete(id).then(() => (this.dialog = false));
		},
		...mapActions({
			fetchPayments: 'Payments/fetchPaymentsOfThePlace',
			delete: 'Payments/deleteOnePayment',
			edit: 'Payments/editPayment',
		}),
	},
};
</script>

<style lang="scss" scoped>
.bg {
	background-color: #e8d8ca;
}
</style>
